export const DEFAULT_HEADER = {
  'SB-Agent': 'SB-FE',
  'SB-Agent-Version': process.env.VUE_APP_VERSION || '2.0.0',
}

export default DEFAULT_HEADER
